module.exports = __webpack_public_path__ + "static/iconplus-black-1f9450384c630797ebc34289667e8517.svg";